import { useNavigate } from "react-router-dom";
import "./sub-header-style.scss";

//次層頁面的頂部列
//
//  首頁用的是 nav-list（logo + 分類），次層頁面用這支（返回 + 標題）。
//  分成兩個元件而不是在 nav-list 裡加判斷：兩者的結構和行為差很多，
//  混在一起會變成一堆 if。
//
//  props:
//    title     置中標題；省略則顯示品牌名
//    fallback  沒有上一頁時的返回目的地（預設首頁）
const SubHeader = ({ title, fallback = "/" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    //直接開這個網址進來時（例如從分享連結）history 沒有上一頁，
    //navigate(-1) 會離開本站 → 改導去指定的退路
    if (window.history.state?.idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  };

  return (
    <header className="sub-header">
      <button type="button" className="sub-header__back" onClick={handleBack} aria-label="返回">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
          <path d="M15 5l-7 7 7 7" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <h1 className="sub-header__title">{title || "閻異閣"}</h1>

      {/* 佔位：讓標題在視覺上真正置中，而不是被返回鍵擠偏 */}
      <span className="sub-header__spacer" aria-hidden="true" />
    </header>
  );
};

export default SubHeader;
